module.exports = __webpack_public_path__ + "img/park-operation.e70fc321.jpg";